module.exports = __webpack_public_path__ + "static/media/ignis.a8411f9d.svg";